import { render } from "./AdminVerification.vue?vue&type=template&id=36b87755&scoped=true"
import script from "./AdminVerification.vue?vue&type=script&lang=js"
export * from "./AdminVerification.vue?vue&type=script&lang=js"

import "./AdminVerification.vue?vue&type=style&index=0&id=36b87755&lang=css"
import "./AdminVerification.vue?vue&type=style&index=1&id=36b87755&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b87755"]])

export default __exports__